import { Formik } from "formik";
import { Text } from "../../../../../components/general/Text";
import SectionInterface from "../../../../../interfaces/SectionInterface";
import { StudentPasscodeInactivationConfirmModal } from "../StudentPasscodeInactivationConfirmModal";
import { useStudentPasscodeInactivationConfirmation } from "../StudentPasscodeInactivationConfirmModal/useStudentPasscodeInactivationConfirmation";
import styles from "../styles.scss";
import { InnerForm } from "./InnerForm";
import { useImportStudentPasscodeInactivation } from "./useImportStudentPasscodeInactivation";
import { validationSchema } from "./validationSchema";

type Values = {
  csv: Blob | undefined;
};

export const UploadForm = ({ section }: { section: SectionInterface }) => {
  const {
    isConfirmModalOpen,
    csvData,
    csvFile,
    importConfirmationTargetPeople,
    handleCloseModal,
    setIsConfirmModalOpen,
  } = useStudentPasscodeInactivationConfirmation(section);

  const { importStudentPasscodeInactivation } =
    useImportStudentPasscodeInactivation({
      sectionId: section.id,
      setIsConfirmModalOpen,
    });

  const initialValues: Values = { csv: undefined };

  return (
    <div className={styles.box}>
      <div className={styles.boxHeading}>
        <Text className={styles.boxHeadingTitle}>
          3. 情報を保存したCSVファイルをアップロード
        </Text>
        <Text className={styles.notice}>
          ※エクセル形式ではインポートできませんので、必ずCSV形式で保存してください。
        </Text>
      </div>
      <div className={styles.buttons}>
        <Formik<Values>
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={importConfirmationTargetPeople}
        >
          {(formikProps) => <InnerForm {...formikProps} />}
        </Formik>
      </div>

      <StudentPasscodeInactivationConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={handleCloseModal}
        onConfirm={(reason, setFieldError) =>
          importStudentPasscodeInactivation(csvFile, reason, setFieldError)
        }
        studentCount={csvData?.total_student_count_for_inactivation || 0}
        studentCountByGrade={
          csvData?.student_counts_for_inactivation.map((item) => ({
            grade: item.job,
            count: item.count,
          })) || []
        }
      />
    </div>
  );
};
